(function () {
  'use strict';

  /* @ngdoc object
   * @name costCenters.list
   * @description
   *
   */
  angular
    .module('timeTracking.costCenters.list', [
      'ui.router'
    ]);
}());
